function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "-38 0 512 512.001"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M217.996 158.457c-53.793 0-97.555 43.762-97.555 97.55 0 53.794 43.762 97.556 97.555 97.556 53.79 0 97.55-43.762 97.55-97.555 0-53.79-43.76-97.551-97.55-97.551m57.918 79.18-69.887 69.886a14.98 14.98 0 0 1-10.625 4.403 14.96 14.96 0 0 1-10.62-4.403l-26.708-26.707c-5.867-5.863-5.867-15.375 0-21.242 5.863-5.867 15.375-5.867 21.242 0l16.086 16.086 59.27-59.265c5.863-5.868 15.375-5.868 21.242 0 5.867 5.863 5.867 15.375 0 21.242m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.488 138.918-.015-.398a534 534 0 0 1-.461-15.91c-.418-28.231-22.86-51.583-51.094-53.16-58.867-3.286-104.406-22.481-143.316-60.407l-.332-.316c-12.692-11.637-31.836-11.637-44.532 0l-.332.316c-38.91 37.926-84.449 57.121-143.316 60.41C23.86 71.027 1.414 94.38.996 122.613a528 528 0 0 1-.46 15.907l-.024.925C-.633 199.473-2.055 274.18 22.938 341.988c13.742 37.29 34.554 69.703 61.855 96.348 31.094 30.344 71.82 54.434 121.047 71.598a37.4 37.4 0 0 0 4.96 1.351c2.391.477 4.798.715 7.204.715s4.816-.238 7.203-.715a37.5 37.5 0 0 0 4.98-1.36c49.168-17.195 89.852-41.296 120.918-71.636 27.29-26.652 48.102-59.074 61.856-96.371 25.086-68.012 23.668-142.86 22.527-203M217.996 383.605c-70.36 0-127.598-57.238-127.598-127.597 0-70.36 57.239-127.598 127.598-127.598 70.356 0 127.598 57.238 127.598 127.598s-57.242 127.597-127.598 127.597m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }));
};
export default SvgShield;